import { Entity, Field } from "typegraph";

import { ID } from "common/entities/IEntity";

@Entity({one: "product", many: "products"})
export default class Product {

	@Field()
	public id: ID;

	@Field()
	public name: string;

	@Field()
	public subTitle?: string;

}



// WEBPACK FOOTER //
// ./src/panels/programStatus/entities/Product.ts